const heightPercent = (percent: number) => {
  return (percent / 100) * window.innerHeight;
};

export default heightPercent;
